module.exports = __webpack_public_path__ + "img/menu_xmas_gnomes.9bbf1024.png";